<script lang="ts">
import { modalRegister } from '@/services/modals';
import ConfirmModal from './ConfirmModal.vue';
import type { ButtonVariants } from '../../../cross-app-frontend/button';

export async function confirmModal<T = boolean>(args: {
  title: string;
  message: string;
  choices?: { label: string; value: T; icon: string; variant: ButtonVariants['variant'] }[];
  defaultCloseValue?: T;
  dialogStyle?: string;
}): Promise<T> {
  return modalRegister({
    content: ConfirmModal,
    bindings: {
      choices: [
        { label: 'Cancel', value: false, icon: 'fa-xmark', variant: 'outline' },
        { label: 'Proceed', value: true, icon: 'fa-check', variant: 'default' },
      ],
      defaultCloseValue: false,
      ...args,
    },
  });
}
</script>

<script setup lang="ts">
import BootstrapModal from '@/components/modals/BootstrapModal.vue';
import { ref } from 'vue';
import { type ModalItem } from '@/services/modals';
import { Button } from '../../../cross-app-frontend/button';

defineProps<{
  modalID: ModalItem['modalID'];
  title: string;
  message: string;
  choices: { label: string; value: any; icon: string; variant: ButtonVariants['variant'] }[];
  defaultCloseValue: any;
  dialogStyle?: string | undefined;
}>();

const modal = ref<InstanceType<typeof BootstrapModal> | null>(null);
defineExpose({ modal });
</script>

<template>
  <BootstrapModal ref="modal" :title="title" :modalID="modalID" :defaultCloseValue="defaultCloseValue" :dialogStyle>
    <p style="white-space: pre-line">{{ message }}</p>

    <template #footer="{ close }">
      <Button
        v-for="(choice, index) of choices"
        type="button"
        :key="index"
        :variant="choice.variant"
        @click="close(choice.value)"
      >
        <i class="fa-light" :class="choice.icon"></i>
        {{ choice.label }}
      </Button>
    </template>
  </BootstrapModal>
</template>
